module.exports = __webpack_public_path__ + "img/tt.db362840.svg";